import _constants from "../components/_constants";

const getFigurePositions = (firstIndexByColumn, isInitial) => {
  const columnIndex = isInitial ? 2 : 3;

  return _constants.candleBlockSize * (firstIndexByColumn[columnIndex] - 1);
};

export default getFigurePositions;
